import { RefreshCw, Plus } from "lucide-react"
import { colors } from "../../styles/theme"

interface TournamentHeaderProps {
  onRefresh: () => void
}

export function TournamentHeader({ onRefresh }: TournamentHeaderProps) {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold" style={{ color: colors.text.primary }}>
            Drag Racing Series Tournament Management
          </h1>
          <p className="mt-1 text-sm" style={{ color: colors.text.secondary }}>
            Manage elimination brackets, re-entry rounds, and track ladder points for multi-date series
          </p>
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={onRefresh}
            className="inline-flex items-center gap-2 px-3 py-2 text-sm font-medium border rounded-lg hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2"
            style={{
              color: colors.text.primary,
              backgroundColor: colors.background.secondary,
              borderColor: colors.border.primary,
            }}
          >
            <RefreshCw className="h-4 w-4" />
            Refresh
          </button>
        </div>
      </div>
    </div>
  )
} 